import { Icon } from "common/LegacyIcon";
import { Popover } from "common/Popover";
import * as reportActions from "lib/api/rideReports";
import { featureNames, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { connect } from "react-redux";
import { alignFix } from "./GalleryBlock.scss";
const preventDefault = (e) => e.preventDefault();

export const GalleryPopover = ({
  setFeaturedImage,
  reportId,
  isFeatured,
  reselectPhotos,
  displayAsPostcard,
  editingPostcard,
  canEmbiggen,
  size,
  imageIds,
  toggleEditPostcard,
  embiggen,
  shrink,
  togglePostcard,
  toggleHelp,
}) => (
  <Popover onMouseDown={preventDefault}>
    {imageIds.length === 1 &&
      (isFeatured ? (
        <li className={alignFix}>
          <Icon i="star" size={16} alignMiddle={false} />
          <span>
            {" "}
            <T id="GalleryPopover.currentCover" defaultMessage="current cover image" />
          </span>
        </li>
      ) : (
        <li onClick={() => setFeaturedImage(reportId, imageIds[0])}>
          <T id="GalleryPopover.setAsCover" defaultMessage="set as cover" />
        </li>
      ))}
    <li onClick={reselectPhotos}>
      <T id="GalleryPopover.changePhotos" defaultMessage="change photos" />
    </li>
    {displayAsPostcard &&
      (editingPostcard ? (
        <li onClick={toggleEditPostcard}>
          <T id="GalleryPopover.doneEditing" defaultMessage="done editing" />
        </li>
      ) : (
        <li onClick={toggleEditPostcard}>
          <T id="GalleryPopover.reposition" defaultMessage="reposition photos" />
        </li>
      ))}
    {canEmbiggen &&
      (size === "normalBlock" ? (
        <li onClick={embiggen}>
          <T id="GalleryPopover.bigger" defaultMessage="bigger" />
        </li>
      ) : (
        <li onClick={shrink}>
          <T id="GalleryPopover.smaller" defaultMessage="smaller" />
        </li>
      ))}
    {imageIds.length > 1 &&
      (displayAsPostcard ? (
        <li onClick={togglePostcard}>
          <T id="GalleryPopover.gallery" defaultMessage="switch to gallery" />
        </li>
      ) : (
        <li onClick={togglePostcard}>
          <T id="GalleryPopover.postcard" defaultMessage="switch to postcard" />
        </li>
      ))}
    <li onClick={toggleHelp}>
      <Icon i="help" size={14} /> <Msg lowerCase m={featureNames.help} />
    </li>
  </Popover>
);

const mapDispatchToProps = {
  setFeaturedImage: reportActions.setFeaturedImage,
};

const mapStateToProps = (state, ownProps) => ({
  isFeatured:
    ownProps.imageIds &&
    ownProps.imageIds.length === 1 &&
    ownProps.imageIds[0] === state.rideReports.reports.get(ownProps.reportId).featuredImage,
});

export const GalleryPopoverContainer = connect(mapStateToProps, mapDispatchToProps)(GalleryPopover);
